export default [
  {
    path: "/reservation",
    meta: { hideLogo: true, hideAppBar: false, hideBottomNavigation: true, fullWidth: true, navbarTitle: "Reservationen" },
    name: "ReservationTypeSelection",
    component: () => import("@/views/reservationTool/views/ReservationTypeSelection.vue"),
  },

  {
    path: "/reservation/:reservationTypeId",
    name: "ReservationBooking",
    meta: { hideLogo: true, hideAppBar: false, hideBottomNavigation: true, fullWidth: true, navbarTitle: "Reservationen" },
    component: () => import("@/views/reservationTool/ReservationTool.vue"),
  },
]
